export default __webpack_public_path__ + "static/media/twitterLogo.84a72906.webp";